<template>
  <el-card class="logistics-card">
    <el-form :model="logisticsForm" >
      <el-form-item :label="$t('mobile.outSelect.reasion')">
        <el-select
            v-model="formInline.channelId"
            filterable
            reserve-keyword
            :placeholder="$t('mobile.outSelect.rprompt')"
            remote-show-suffix
            :loading="loading"
            style="width: 200px"
        >
          <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.label"
              :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item  :label="$t('mobile.outSelect.reasions')">
        <el-input rows="3" v-model="formInline.sendNumber" :placeholder="$t('mobile.outSelect.reasionM')"  style="width: 200px" type="textarea"  ></el-input>
      </el-form-item>
      <div class="flex flex-row-center">
        <el-button  type="primary"  @click="syncLogistics">{{$t('mobile.outSelect.delay')}}</el-button>
      </div>

    </el-form>
  </el-card>
</template>

<script>
import {ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput,ElMessage} from "element-plus";
import {outSendDelay} from "@/utils/api";
export default {
  name: "outSelect",
  components:{
    ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput
  },
  data() {
    return {
      lang: this.$i18n.locale,
      formInline: {
        sendSaleNumber:"",
        channelId:"",
        sendNumber:"",
        reasonCN:"",
        reasonEN:"",
      },
      channelList:[],
    };
  },
  beforeMount() {
    this.formInline.sendSaleNumber = this.$route.query.sendSaleNumber;
    if (this.lang === 'en') {
      this.channelList = [
        {id:1,label: 'No goods', value: '没有货'},
        {id:2,label: 'Not yet collected', value: '暂未揽件'},
        {id:3,label: 'Too many pending shipments', value: '待发货过多'},
        {id:4,label: 'Others', value: ''},
      ]
    }else{
      this.channelList = [
        {id:1,label: '没有货', value: 'No goods'},
        {id:2,label: '暂未揽件', value: 'Not yet collected'},
        {id:3,label: '待发货过多', value: 'Too many pending shipments'},
        {id:4,label: '其它', value: ''},
      ]
    }
  },
  methods: {
    syncLogistics() {
      if (!this.formInline.sendSaleNumber){
        ElMessage.error(this.$t('mobile.outSelect.return'))
        return
      }

      if (!this.formInline.channelId){
        ElMessage.error(this.$t('mobile.outSelect.rprompt'))
        return
      }
      let curSelect = this.channelList.find(item=>{
        return item.id == this.formInline.channelId
      })
      console.log(curSelect)
      if (this.lang==='en'){
        this.formInline.reasonCN = curSelect.value
        this.formInline.reasonEN = curSelect.label
      }else{
        this.formInline.reasonCN = curSelect.label
        this.formInline.reasonEN = curSelect.value
      }
      if (curSelect.id === 4){
        this.formInline.reasonCN = "其它"
        this.formInline.reasonEN = 'Others'
      }
      if (this.formInline.channelId == 4 && !this.formInline.sendNumber){
        if (!this.formInline.sendNumber){
          ElMessage.error(this.$t('mobile.outSelect.reasionM'))
          return
        }
      }
      this.formInline.remarks = this.formInline.sendNumber

      outSendDelay(this.formInline).then(res=>{
        ElMessage.success(this.$t('saveSuccess') )
         // 等待1秒
         setTimeout(() => {
           this.$router.push('/outList');
         }, 1000);
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>

<style scoped>
.logistics-card {
  margin: 20px;
  padding: 20px;
  border-radius: 10px;
}
</style>
